import { Icon } from "@ttc3k/trekker";
import { Sparks } from "iconoir-react";
import { limitFill } from "@cloudinary/transformation-builder-sdk/actions/resize";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";
import { Box, Flex } from "styled-system/jsx";
import { css } from "styled-system/css";
import { CloudinaryImage } from "shared/components/atoms";
import { useWorkbenchWhereabotAvatarQuery } from "gql/generated";

const whereabotUserId = import.meta.env.VITE_WHEREABOT_USER_ID as string | undefined;

/** Photo from the Whereabot AI People record (VITE_WHEREABOT_USER_ID), then its user record, then an icon. */
export const WhereabotAvatar = ({ size = 32 }: { size?: number }) => {
  const { data } = useWorkbenchWhereabotAvatarQuery({
    variables: { userId: whereabotUserId },
    skip: !whereabotUserId,
    fetchPolicy: "cache-first",
    errorPolicy: "all",
  });
  const photo = data?.personFindOne?.photo ?? data?.userFindOne?.photo;
  const px = `${size}px`;

  if (!photo?._id) {
    return (
      <Flex
        w={px}
        h={px}
        minW={px}
        borderRadius="full"
        bg="bg.warning.light"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        <Icon Element={Sparks} size="sm" color="icon.warning.mid" />
      </Flex>
    );
  }

  return (
    <Box w={px} h={px} minW={px} borderRadius="full" overflow="hidden" flexShrink={0}>
      <CloudinaryImage
        image={photo}
        alt="Whereabot"
        imageStyleProps={{
          className: css({ borderRadius: "full", objectFit: "cover", w: "full", h: "full" }),
        }}
        resize={limitFill().width(size * 2).height(size * 2).gravity(autoGravity())}
      />
    </Box>
  );
};
